!function(e){"undefined"==typeof module?this.charming=e:module.exports=e}(function(e,n){"use strict";n=n||{};var t=n.tagName||"span",o=null!=n.classPrefix?n.classPrefix:"char",r=1,a=function(e){for(var n=e.parentNode,a=e.nodeValue,c=a.length,l=-1;++l<c;){var d=document.createElement(t);o&&(d.className=o+r,r++),d.innerHTML=(a.charCodeAt(l)===32?'&nbsp;':a[l]),n.insertBefore(d,e)}n.removeChild(e)};return function c(e){for(var n=[].slice.call(e.childNodes),t=n.length,o=-1;++o<t;)c(n[o]);e.nodeType===Node.TEXT_NODE&&a(e)}(e),e});

{
    const body = document.body;
    const docEl = document.documentElement;

    const lineEq = ( y2, y1, x2, x1, currentVal ) => {
        // y = mx + b
        var m = (y2 - y1) / (x2 - x1), b = y1 - m * x1;
        return m * currentVal + b;
    };

    const lerp = ( a, b, n ) => (1 - n) * a + n * b;

    const distance = ( x1, x2, y1, y2 ) => {
        var a = x1 - x2;
        var b = y1 - y2;
        return Math.hypot( a, b );
    };

    const getMousePos = ( e ) => {
        let posx = 0;
        let posy = 0;
        if ( !e ) e = window.event;
        if ( e.pageX || e.pageY ) {
            posx = e.pageX;
            posy = e.pageY;
        } else if ( e.clientX || e.clientY ) {
            posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
            posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
        }
        return { x: posx, y: posy }
    }

    class Menu {
        constructor() {
            this.DOM = {
                // The SVG element
                svg: document.querySelector( 'svg.distort' ),
                // The menu element
                menu: document.querySelector( 'nav.distort-menu' ),
                //
                distortCont: document.querySelector( '.distort-wrap' ),
                // The feDisplacementMap element
                feDisplacementMapEl: document.querySelector( 'feDisplacementMap' )
            };

            // Window size
            const calcWinsize = () => this.winsize = {
                width: window.innerWidth - this.DOM.distortCont.offsetWidth,
                height: window.innerHeight - this.DOM.distortCont.offsetHeight
            };
            calcWinsize();
            window.addEventListener( 'resize', calcWinsize );

            // The images (one per menu link)
            this.DOM.imgs = [...this.DOM.svg.querySelectorAll( 'g > image' )];
            // The menu links
            this.DOM.menuLinks = [...this.DOM.menu.querySelectorAll( '.distort-menu-link' )];
            // Mouse position
            this.mousePos = { x: this.winsize.width / 2, y: this.winsize.height / 2 };
            // Last mouse positions (one to consider for the image translation movement, another for the scale value of the feDisplacementMap element)
            this.lastMousePos = {
                translation: { x: this.winsize.width / 2, y: this.winsize.height / 2 },
                displacement: { x: 0, y: 0 }
            };
            // feDisplacementMap scale value
            this.dmScale = 0;
            // Current menu link position
            this.current = -1;

            this.contTop = this.DOM.distortCont.getBoundingClientRect().top + window.scrollY;
            this.contLeft = this.DOM.distortCont.getBoundingClientRect().left + window.scrollX;

            this.initEvents();
            requestAnimationFrame( () => this.render() );
        }

        initEvents() {
            // Update mouse position
            window.addEventListener( 'mousemove', ev => this.mousePos = getMousePos( ev ) );

            this.DOM.menuLinks.forEach( ( item, pos ) => {
                // Create spans for each letter
                if ( window.innerWidth > 640 ) {
                    charming( item );
                }
                const letters = [...item.querySelectorAll( 'span' )];

                const mouseenterFn = () => {
                    // Hide the previous menu image.
                    if ( this.current !== -1 ) {
                        gsap.set( this.DOM.imgs[this.current], { opacity: 0 } );
                    }
                    // Update current.
                    this.current = pos;

                    // Now fade in the new image if we are entering the menu or just set the new image's opacity to 1 if switching between menu items.
                    if ( this.fade ) {
                        gsap.to( this.DOM.imgs[this.current], { ease: Quad.easeOut, opacity: 1, duration: .5 } );
                        this.fade = false;
                    } else {
                        gsap.set( this.DOM.imgs[this.current], { opacity: 1 } );
                    }

                    // Letters effect
                    gsap.staggerTo( letters, {
                        ease: Sine.easeInOut,
                        y: this.lastMousePos.translation.y < this.mousePos.y ? 30 : -30,
                        startAt: { opacity: 1, y: 0 },
                        opacity: 0,
                        yoyo: true,
                        yoyoEase: Back.easeOut,
                        repeat: 1,
                        duration: .2,
                        stagger: {
                            grid: [1, letters.length - 1],
                            from: 'center',
                            amount: 0.12
                        }
                    } );
                };
                item.addEventListener( 'mouseenter', mouseenterFn );
            } );

            const mousemenuenterFn = () => this.fade = true;
            const mousemenuleaveFn = () => gsap.to( this.DOM.imgs[this.current], { ease: Quad.easeOut, opacity: 0, duration: .2 } );

            this.DOM.menu.addEventListener( 'mouseenter', mousemenuenterFn );
            this.DOM.menu.addEventListener( 'mouseleave', mousemenuleaveFn );
        }

        render() {
            // Translate the image on mousemove
            this.lastMousePos.translation.x = lerp( this.lastMousePos.translation.x, this.mousePos.x, 0.2 );
            this.lastMousePos.translation.y = lerp( this.lastMousePos.translation.y, this.mousePos.y, 0.2 );
            this.DOM.svg.style.transform = `translateX(${Math.round( (this.lastMousePos.translation.x - this.contLeft) * 100 ) / 100}px) translateY(${Math.round( (this.lastMousePos.translation.y - this.contTop) * 100 ) / 100}px)`;

            // Scale goes from 0 to 50 for mouseDistance values between 0 to 140
            this.lastMousePos.displacement.x = lerp( this.lastMousePos.displacement.x, this.mousePos.x, 0.1 );
            this.lastMousePos.displacement.y = lerp( this.lastMousePos.displacement.y, this.mousePos.y, 0.1 );
            const mouseDistance = distance( this.lastMousePos.displacement.x, this.mousePos.x, this.lastMousePos.displacement.y, this.mousePos.y );
            this.dmScale = Math.min( lineEq( 50, 0, 140, 0, mouseDistance ), 50 );
            this.DOM.feDisplacementMapEl.scale.baseVal = this.dmScale;

            requestAnimationFrame( () => this.render() );
        }
    }

    if ( document.querySelector( '.distort-wrap' ) ) {
        new Menu();
    }
    window.Menu = Menu;
}
